import * as React from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";

const stripePromise = loadStripe(
  // NICKI ACCOUNT
  // "pk_test_51RUzwrP3RFc9T0wf970llUox9Wm0HW10EaajRfnrXAD4SsZySLCmBYfRo65jB8zOrJ3jqgXgMN62rYxNdPM8X9Yf00p2QEgrOd",
  // NICKI LIVE ACCOUNT
  "pk_live_51RUzwj08Lrh8yUaaZuJ6ZikwCugP6AfMCWZPIF94b2fpG45K6O6w2UnsIahN1PudRh3bBELTao5R40GqDTW5kPH300WVFmFsnw",
  {}
);

const CheckoutForm = ({ clientSecret }) => {
  const options = { clientSecret };

  return (
    <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
};

export default CheckoutForm;
